export const PWS_CONTACTS_BASE_URL = `${process.env.REACT_APP_ENDPOINT}/api/pws-contacts-management`;

export const PWS_CONTACT_PK_FIELD = "access_contact_ndx";

export const COLUMNS = [
  {
    field: "access_contact_ndx",
    headerName: "Contact ID",
    width: 90,
    editable: false,
    type: "number",
  },
  {
    field: "contact",
    headerName: "Contact Name",
    width: 200,
    editable: true,
  },
  {
    field: "last_name",
    headerName: "Last Name",
    width: 150,
    editable: true,
  },
  {
    field: "first_name",
    headerName: "First Name",
    width: 150,
    editable: true,
  },
  {
    field: "phone",
    headerName: "Phone",
    width: 150,
    editable: true,
  },
  {
    field: "mobile",
    headerName: "Mobile",
    width: 150,
    editable: true,
  },
  {
    field: "fax",
    headerName: "Fax",
    width: 150,
    editable: true,
  },
  {
    field: "email",
    headerName: "Email",
    width: 200,
    editable: true,
  },
  {
    field: "address",
    headerName: "Address",
    width: 220,
    editable: true,
  },
  {
    field: "city",
    headerName: "City",
    width: 150,
    editable: true,
  },
  {
    field: "state",
    headerName: "State",
    width: 70,
    editable: true,
  },
  {
    field: "zip",
    headerName: "Zip Code",
    width: 90,
    editable: true,
  },
  {
    field: "tceq_number",
    headerName: "TCEQ Number",
    width: 150,
    editable: true,
  },
  {
    field: "tx_license_no",
    headerName: "TX License No",
    width: 150,
    editable: true,
  },
  {
    field: "user_id",
    headerName: "User ID",
    width: 120,
    editable: true,
  },
  {
    field: "notes",
    headerName: "Notes",
    width: 200,
    editable: true,
  },
  // Note: role field is not included since it's always 1 and hidden from users
];
